import { Navigate } from "react-router-dom";

export const PrivateRoute = ({ isAuthenticated, children, role, allowedRoles=[]}) => {
  return (isAuthenticated && 
          ((JSON.stringify(allowedRoles)=== JSON.stringify([])) || allowedRoles.includes(role)))
    ? children
    : <Navigate to="/autenticacion" />
}
